import { useState, useEffect } from "react";
import { RegisterForm, About, Contact, Header, Login2, Pricing, Skill, Team, Request, NewNavbar, Product, Profile} from "./../component/public_component";
import { AuthProvider } from "./../context/AuthContext";
import {Blog} from './../Blog'
export const MainPage = () => {
    const [showLoginModal, setshowLoginModal] = useState(false)
    const toggleShowModalLogin = () => setshowLoginModal(!showLoginModal)

    const [showRegModal, setshowRegModal] = useState(false)
    const toggleShowModalReg = () => setshowRegModal(!showRegModal)

    const [showReqModal, setshowReqModal] = useState(false)
    const toggleShowModalReq = () => setshowReqModal(!showReqModal)

    const [showProfileModal, setShowProfileModal] = useState(false)
    const toggleShowProfileModal = () => setShowProfileModal(!showProfileModal)

    // ⬇️ مودال نتیجه پرداخت
    const [paymentModal, setPaymentModal] = useState({ show: false, type: 'success', message: '' });

    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const paymentStatus = params.get('payment');

      if (paymentStatus === 'success') {
        setPaymentModal({
          show: true,
          type: 'success',
          message: 'پرداخت شما با موفقیت انجام شد و عضویت‌تان فعال گردید. اکنون می‌توانید از امکانات دانلود استفاده کنید.'
        });
        window.history.replaceState({}, '', window.location.pathname);
      } else if (paymentStatus === 'failed') {
        setPaymentModal({
          show: true,
          type: 'error',
          message: 'متاسفانه پرداخت شما ناموفق بود. لطفا دوباره تلاش کنید یا با پشتیبانی تماس بگیرید.'
        });
        window.history.replaceState({}, '', window.location.pathname);
      } else if (paymentStatus === 'cancelled') {
        setPaymentModal({
          show: true,
          type: 'warning',
          message: 'پرداخت توسط شما لغو شد. در صورت تمایل می‌توانید مجدداً اقدام به خرید نمایید.'
        });
        window.history.replaceState({}, '', window.location.pathname);
      }
    }, []);

    const closePaymentModal = () => {
      setPaymentModal({ show: false, type: 'success', message: '' });
    };

    const modalColors = {
      success: '#15ff00',
      error: '#ff0000',
      warning: '#ff9800'
    };

    const modalIcons = {
      success: 'check_circle',
      error: 'cancel',
      warning: 'info'
    };

    const modalTitles = {
      success: 'پرداخت موفق',
      error: 'پرداخت ناموفق',
      warning: 'پرداخت لغو شد'
    };

    return (
        <AuthProvider>
            <NewNavbar
                onLoginClick={toggleShowModalLogin}
                onRegClick={toggleShowModalReg}
                onReqClick={toggleShowModalReq}
                onProfileClick={toggleShowProfileModal}
            />
            <Header />
            <Product />
            <Pricing />
            <Blog />
            <About />
            <Skill />
            <Team />
            <Contact />
            <Login2 visible={showLoginModal} onHide={toggleShowModalLogin} />
            <Request visible={showReqModal} onHide={toggleShowModalReq} />
            <RegisterForm visible={showRegModal} onHide={toggleShowModalReg} />
            <Profile visible={showProfileModal} onHide={toggleShowProfileModal} />

            {/* مودال نتیجه پرداخت */}
            {paymentModal.show && (
              <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                <div
                  className="w3-card-4 w3-animate-zoom"
                  style={{
                    backgroundColor: '#263238',
                    borderTopLeftRadius: '20px',
                    borderBottomRightRadius: '20px',
                    maxWidth: '360px',
                    width: '90%',
                    direction: 'rtl',
                    overflow: 'hidden'
                  }}
                >
                  <div
                    className="w3-container w3-padding"
                    style={{
                      backgroundColor: `${modalColors[paymentModal.type]}22`,
                      borderBottom: `2px solid ${modalColors[paymentModal.type]}`
                    }}
                  >
                    <span onClick={closePaymentModal} className="w3-button w3-display-topright" style={{ color: 'white' }}>
                      &times;
                    </span>
                    <h4 className="w3-text-white" style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
                      <i className="material-icons w3-margin-left" style={{ color: modalColors[paymentModal.type] }}>
                        {modalIcons[paymentModal.type]}
                      </i>
                      {modalTitles[paymentModal.type]}
                    </h4>
                  </div>

                  <div className="w3-container w3-padding" style={{ textAlign: 'center' }}>
                    <i
                      className="material-icons"
                      style={{ fontSize: 60, color: modalColors[paymentModal.type], marginBottom: 10 }}
                    >
                      {modalIcons[paymentModal.type]}
                    </i>
                    <p className="w3-text-white">{paymentModal.message}</p>
                  </div>

                  <div className="w3-container w3-padding" style={{ paddingBottom: '15px' }}>
                    <button
                      onClick={closePaymentModal}
                      className="w3-button w3-block"
                      style={{
                        color: modalColors[paymentModal.type],
                        backgroundColor: 'transparent',
                        border: `2px solid ${modalColors[paymentModal.type]}`,
                        borderRadius: '10px'
                      }}
                    >
                      باشه
                    </button>
                  </div>
                </div>
              </div>
            )}
        </AuthProvider>
    )
}